export const ERROR_MESSAGES: {[key: string]: string} = {
  forgotPasswordDeloitte: 'Deloitte emails aren\'t allowed to reset passwords',
  emailFormat: 'Incorrect format of the email',
  invalidEmailAddress: 'Invalid email address',
  generic: 'There was a problem processing your request. Please try again later.',
  required: 'Value required',
  isEmpty: 'Value required',
  passwordFormat: 'The password you entered does not meet the required format.',
  nonDeloitteEmail: 'You cannot use Deloitte email to sign-up',
  confirmedValidator: 'Passwords do not match',
};
